import Logo from "../../assets/img/svg/logo-navbar.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <img src={Logo} alt="Logo" />
    </footer>
  );
};

export default Footer;
